import { render, staticRenderFns } from "./detail_result.vue?vue&type=template&id=00ce3a1c&scoped=true&"
import script from "./detail_result.vue?vue&type=script&lang=js&"
export * from "./detail_result.vue?vue&type=script&lang=js&"
import style0 from "./detail_result.vue?vue&type=style&index=0&id=00ce3a1c&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00ce3a1c",
  null
  
)

export default component.exports